import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import matchSorter from "match-sorter";

import * as modalActions from "../../actions/modalActions";
import * as customerActions from "../../actions/customerActions";
import * as userActions from "../../actions/userActions";
import * as expenseActions from "../../actions/expenseActions";
import * as projectActions from "../../actions/projectActions";

import HeaderWrapper from "../common/HeaderWrapper";
import ExpenseList from "../expense/ExpenseList";
import ExpenseForm from "../expense/ExpenseForm";
import Modal from "../common/Modal";
import ConfirmModal from "../common/ConfirmModal";

class ProjectExpensePage extends Component {
  constructor(props) {
    super(props);
    this.state = { search: "" };
  }

  async componentDidMount() {
    const { users, match, actions, project } = this.props;
    await actions.getProject(match.params.id);
    actions.loadExpensesByCustomerId(project.customer._id);
    if (!users.length) actions.loadUsers();
  }

  onClickAdd = () => {
    this.setState({ adding: true });
    this.props.actions.showModalSuccess("expenseDetailsModal");
  };

  onClickView = (expense) => {
    this.setState({ adding: false });
    this.props.actions.getExpense(expense, true);
  };

  onClickDelete = (expenseId) => {
    this.props.actions.requestExpenseId(expenseId);
  };

  handleDelete = () => {
    this.props.actions.deleteExpense(this.props.expenseToDelete);
  };

  handleAdd = async (expense) => {
    await this.props.actions.createExpense(expense);
    await this.props.actions.loadExpensesByCustomerId(
      this.props.project.customer._id
    );
    this.props.actions.hideModal();
  };

  handleSave = async (expense) => {
    await this.props.actions.updateExpense(expense);
    await this.props.actions.loadExpensesByCustomerId(
      this.props.project.customer._id
    );
    this.props.actions.hideModal();
  };

  filter = (e) => this.setState({ search: e.target.value });

  render() {
    const { expenses, expense, users, codes, saving, isMobile, auth, project } =
      this.props;
    const { search, adding } = this.state;
    const { customer } = project;

    const innerExpenses = expenses.filter(
      (exp) => exp.project === this.props.project._id
    );

    const innerExpense = adding
      ? {
          customer: customer._id,
          project: project.id
        }
      : expense;

    const expenseForm = (
      <ExpenseForm
        expense={innerExpense}
        // customers={[customer]}
        customer={customer._id}
        codes={codes}
        users={users}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.props.actions.hideModal}
        adding={adding}
        saving={saving}
        editing
        auth={auth}
        project={project}
        projects={project}
        hideReceiptDelete
      />
    );

    return (
      <div id="expenses">
        <HeaderWrapper
          breadcrumbs={[{ label: "Expenses" }]}
          onClickAdd={this.onClickAdd}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <ExpenseList
            minimal
            expenses={matchSorter(innerExpenses, search, {
              keys: [
                "date",
                "employee.full_name",
                "customer.name",
                "category.label",
                "amount",
                "status.label"
              ]
            })}
            onClickView={this.onClickView}
            onClickDelete={this.onClickDelete}
            isMobile={isMobile}
          />
        </div>
        <Modal
          id="expenseDetailsModal"
          title={adding ? "Add Expense" : "Edit Expense"}
          body={expenseForm}
          close={this.props.actions.hideModal}
        />
        <ConfirmModal
          id="expenseDeleteModal"
          title="Delete Expense"
          body="Are you sure you want to delete this expense?"
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
      </div>
    );
  }
}

ProjectExpensePage.propTypes = {
  actions: PropTypes.object.isRequired,
  expense: PropTypes.object,
  saving: PropTypes.bool,
  isMobile: PropTypes.bool,
  match: PropTypes.object,
  project: PropTypes.object,
  expenses: PropTypes.array,
  codes: PropTypes.array.isRequired,
  expenseToDelete: PropTypes.string,
  users: PropTypes.array,
  auth: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    customer: state.reducers.customer,
    expense: state.reducers.expense,
    expenses: state.reducers.expenses,
    expenseToDelete: state.reducers.expenseToDelete,
    saving: state.reducers.savingExpense,
    users: state.reducers.users,
    codes: state.reducers.codes,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...expenseActions,
        ...customerActions,
        ...userActions,
        ...projectActions
      },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(ProjectExpensePage)
);
